import { createNanoEvents } from 'nanoevents'

import type { AppTRPCClientError } from '@/utils/error'

interface Events {
  'message': (message: string) => void
  'server-error': (errorCode: number | string, errorMessage: string) => void
  /**
   * 可通过 ignore 参数来控制是否显示错误信息，默认为 false，当设置为 true 时所有的错误处理逻辑都不会执行
   *
   * 回调中可实现普通 message 通知或者各种业务自定义的通知方式
   */
  'trpc-error': (error: AppTRPCClientError, ignore?: boolean) => void
}

export const globalErrorEmitter = createNanoEvents<Events>()
